// document.addEventListener('DOMContentLoaded', function() {
//   const storeData = window.storeData || [];
//   const countrySelect = document.getElementById('store-country-select');
//   const citySelect = document.getElementById('store-city-select');
//   const storeList = document.getElementById('store-list');
//   const nearestBtn = document.getElementById('find-nearest-btn');
//   const radiusContainer = document.getElementById('radius-filter-container');
//   const radiusSelect = document.getElementById('radius-select');
//   const searchStatus = document.getElementById('search-status');

//   let currentStores = [...storeData];
//   let userLocation = null;
  
//   // Initialize Dropdowns
//   initFilters();
//   renderStores(storeData);

//   function initFilters() {
//     // Get unique countries
//     const countries = [...new Set(storeData.map(s => s.country).filter(Boolean))].sort();
//     countries.forEach(c => {
//       const opt = document.createElement('option');
//       opt.value = c;
//       opt.textContent = c;
//       countrySelect.appendChild(opt);
//     });

//     // Country Change
//     countrySelect.addEventListener('change', function() {
//        const selectedCountry = this.value;
//        radiusContainer.classList.add('hidden');
//        searchStatus.textContent = '';
       
//        populateCities(selectedCountry);
//        filterStores();
//     });

//     // City Change
//     citySelect.addEventListener('change', function() {
//        filterStores();
//     });

//     // Radius Change
//     radiusSelect.addEventListener('change', function() {
//         if(userLocation) {
//             filterByDistance();
//         }
//     });

//     // Find Nearest Click
//     nearestBtn.addEventListener('click', function(e) {
//       e.preventDefault();
//       findNearestStores();
//     });
//   }

//   function populateCities(country) {
//     citySelect.innerHTML = '<option value="All">All</option>';
//     if (country === 'All') {
//       citySelect.disabled = true;
//       return;
//     }

//     const cities = [...new Set(storeData
//         .filter(s => s.country === country)
//         .map(s => s.city)
//         .filter(Boolean))].sort();
    
//     cities.forEach(c => {
//       const opt = document.createElement('option');
//       opt.value = c;
//       opt.textContent = c;
//       citySelect.appendChild(opt);
//     });
//     citySelect.disabled = false;
//   }

//   function filterStores() {
//     const country = countrySelect.value;
//     const city = citySelect.value;

//     let filtered = storeData;
//     if (country !== 'All') {
//       filtered = filtered.filter(s => s.country === country);
//     }
//     if (city !== 'All') {
//       filtered = filtered.filter(s => s.city === city);
//     }
    
//     // Reset geolocation sort if manually filtering
//     currentStores = filtered;
//     renderStores(filtered);
//   }

//   function findNearestStores() {
//     if (!navigator.geolocation) {
//       alert("Geolocation is not supported by your browser.");
//       return;
//     }

//     nearestBtn.innerHTML = 'Locating...';

//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         userLocation = {
//           lat: position.coords.latitude,
//           lng: position.coords.longitude
//         };
        
//         nearestBtn.innerHTML = '<svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" /></svg> Use current location';
        
//         radiusContainer.classList.remove('hidden');
//         filterByDistance();
//       },
//       (error) => {
//         nearestBtn.innerHTML = 'Find nearest outlet';
//         alert("Unable to retrieve your location.");
//         console.error(error);
//       }
//     );
//   }

//   function filterByDistance() {
//       if(!userLocation) return;
      
//       const radius = parseInt(radiusSelect.value);
      
//       // Calculate distance for all stores
//       const storesWithDist = storeData.map(store => {
//           if (!store.lat || !store.lng) return { ...store, distance: Infinity };
//           const dist = calculateDistance(userLocation.lat, userLocation.lng, store.lat, store.lng);
//           return { ...store, distance: dist };
//       });
      
//       // Filter by radius
//       const filtered = storesWithDist.filter(s => s.distance <= radius).sort((a,b) => a.distance - b.distance);
      
//       // Update UI
//       searchStatus.textContent = `${filtered.length} Stores found in ${radius}km your radius`;
      
//       // Update Filters to match "Custom" view
//       countrySelect.value = 'All';
//       citySelect.innerHTML = '<option value="All">All</option>';
//       citySelect.disabled = true;

//       renderStores(filtered);
//   }

//   function renderStores(stores) {
//     storeList.innerHTML = '';
    
//     if (stores.length === 0) {
//       storeList.innerHTML = '<p style="grid-column: 1/-1; text-align:center; padding: 20px;">No stores found.</p>';
//       return;
//     }

//     stores.forEach(store => {
//        const div = document.createElement('div');
//        div.className = 'store-card';
       
//        const distBadge = store.distance && store.distance !== Infinity 
//          ? `<span class="store-distance-badge">${store.distance.toFixed(1)} km</span>` 
//          : '';

//        div.innerHTML = `
//           ${distBadge}
//           <div class="store-card-image">
//              <img src="${store.image || '//cdn.shopify.com/s/files/1/0000/0001/files/placeholder.jpg'}" alt="${store.name}">
//              <div class="store-overlay">
//                 <h3 class="store-title">${store.name}</h3>
//                 ${store.url ? `<a href="${store.url}" class="store-link">FIND OUT MORE</a>` : ''}
//              </div>
//           </div>
//        `;
//        storeList.appendChild(div);
//     });
//   }

//   // Haversine Formula
//   function calculateDistance(lat1, lon1, lat2, lon2) {
//     const R = 6371; // Radius of the earth in km
//     const dLat = deg2rad(lat2 - lat1);
//     const dLon = deg2rad(lon2 - lon1);
//     const a =
//       Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//       Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
//       Math.sin(dLon / 2) * Math.sin(dLon / 2);
//     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//     return R * c; // Distance in km
//   }

//   function deg2rad(deg) {
//     return deg * (Math.PI / 180);
//   }

// });


// document.addEventListener('DOMContentLoaded', () => {

//   const storeList = document.getElementById('store-list');
//   const statusText = document.getElementById('search-status');
//   const findNearestBtn = document.getElementById('find-nearest-btn');
//   const radiusContainer = document.getElementById('radius-filter-container');

//   const countryDropdown = document.getElementById('country-dropdown');
//   const cityDropdown = document.getElementById('city-dropdown');

//   const countrySelected = countryDropdown.querySelector('.dropdown-selected');
//   const citySelected = cityDropdown.querySelector('.dropdown-selected');

//   const countryList = countryDropdown.querySelector('.dropdown-list');
//   const cityList = cityDropdown.querySelector('.dropdown-list');

//   const radiusButtons = document.querySelectorAll('.radius-option');
//   const AVAILABLE_RADII = [10, 20, 30, 40, 50];

//   let userLocation = null;

//   /* =====================
//      🔥 NORMALIZE STORE DATA
//   ===================== */
//   const stores = window.storeData.map(store => ({
//     ...store,
//     country: store.country.trim().toUpperCase(),
//     city: store.city.trim()
//   }));

//   /* =====================
//      DEFAULT STATE
//   ===================== */
//   let selectedCountry = 'PAKISTAN';
//   let selectedCity = 'All';

//   /* =====================
//      INIT COUNTRIES
//   ===================== */
//   const countries = [...new Set(stores.map(s => s.country))];

//   countryList.innerHTML = '';
//   countries.forEach(c => {
//     countryList.insertAdjacentHTML(
//       'beforeend',
//       `<li data-value="${c}" class="${c === 'PAKISTAN' ? 'active' : ''}">${c}</li>`
//     );
//   });

//   countrySelected.dataset.value = 'PAKISTAN';
//   countrySelected.querySelector('.selected-text').textContent = 'PAKISTAN';

//   citySelected.dataset.value = 'All';
//   citySelected.querySelector('.selected-text').textContent = 'All';

//   /* =====================
//      DROPDOWN TOGGLE
//   ===================== */
//   document.querySelectorAll('.dropdown-selected').forEach(el => {
//     el.addEventListener('click', e => {
//       const parent = e.currentTarget.closest('.custom-dropdown');
//       if (parent.classList.contains('disabled')) return;
//       parent.classList.toggle('open');
//     });
//   });

//   document.addEventListener('click', e => {
//     if (!e.target.closest('.custom-dropdown')) {
//       document.querySelectorAll('.custom-dropdown').forEach(d => d.classList.remove('open'));
//     }
//   });

//   /* =====================
//      COUNTRY CHANGE
//   ===================== */
//   countryList.addEventListener('click', e => {
//     if (e.target.tagName !== 'LI') return;

//     selectedCountry = e.target.dataset.value;
//     selectedCity = 'All';

//     countrySelected.dataset.value = selectedCountry;
//     countrySelected.querySelector('.selected-text').textContent = selectedCountry;

//     countryList.querySelectorAll('li').forEach(li => li.classList.remove('active'));
//     e.target.classList.add('active');

//     citySelected.querySelector('.selected-text').textContent = 'All';

//     populateCities();
//     renderAllStores();
//   });

//   /* =====================
//      CITY CHANGE
//   ===================== */
//   cityList.addEventListener('click', e => {
//     if (e.target.tagName !== 'LI') return;

//     selectedCity = e.target.dataset.value;

//     citySelected.dataset.value = selectedCity;
//     citySelected.querySelector('.selected-text').textContent = selectedCity;

//     cityList.querySelectorAll('li').forEach(li => li.classList.remove('active'));
//     e.target.classList.add('active');

//     renderAllStores();
//   });

//   /* =====================
//      POPULATE CITIES
//   ===================== */
//   function populateCities() {
//     cityList.innerHTML = `<li data-value="All" class="active">All</li>`;
//     cityDropdown.classList.remove('disabled');

//     const cities = [...new Set(
//       stores
//         .filter(s => s.country === selectedCountry)
//         .map(s => s.city)
//     )];

//     cities.forEach(city => {
//       cityList.insertAdjacentHTML(
//         'beforeend',
//         `<li data-value="${city}">${city}</li>`
//       );
//     });
//   }

//   /* =====================
//      FIND NEAREST
//   ===================== */
//   findNearestBtn.addEventListener('click', () => {
//     if (!navigator.geolocation) return;

//     navigator.geolocation.getCurrentPosition(pos => {
//       userLocation = {
//         lat: pos.coords.latitude,
//         lng: pos.coords.longitude
//       };

//       radiusContainer.classList.remove('hidden');
//       autoSelectRadius();
//     });
//   });

//   function autoSelectRadius() {
//     for (let radius of AVAILABLE_RADII) {
//       const storesInRange = getStoresInRadius(radius);
//       if (storesInRange.length) {
//         setActiveRadius(radius);
//         renderStores(storesInRange);
//         updateStatus(storesInRange.length, radius);
//         return;
//       }
//     }

//     renderStores([]);
//     updateStatus(0, AVAILABLE_RADII.at(-1));
//   }

//   radiusButtons.forEach(btn => {
//     btn.addEventListener('click', () => {
//       if (!userLocation) return;

//       const radius = parseInt(btn.dataset.radius, 10);
//       setActiveRadius(radius);

//       const storesInRange = getStoresInRadius(radius);
//       renderStores(storesInRange);
//       updateStatus(storesInRange.length, radius);
//     });
//   });

//   function setActiveRadius(radius) {
//     radiusButtons.forEach(btn =>
//       btn.classList.toggle('active', parseInt(btn.dataset.radius, 10) === radius)
//     );
//   }

//   function updateStatus(count, radius) {
//     statusText.textContent = count
//       ? `${count} store${count > 1 ? 's' : ''} found within ${radius} km`
//       : `No stores found within ${radius} km`;
//   }

//   function getStoresInRadius(radius) {
//     return stores.filter(store => {
//       if (store.country !== selectedCountry) return false;
//       if (selectedCity !== 'All' && store.city !== selectedCity) return false;

//       const d = getDistance(
//         userLocation.lat,
//         userLocation.lng,
//         store.lat,
//         store.lng
//       );
//       return d <= radius;
//     });
//   }

//   /* =====================
//      RENDER STORES
//   ===================== */
//   function renderAllStores() {
//     let filtered = stores.filter(s => s.country === selectedCountry);

//     if (selectedCity !== 'All') {
//       filtered = filtered.filter(s => s.city === selectedCity);
//     }

//     renderStores(filtered);
//     statusText.textContent = '';
//   }

//   function renderStores(stores) {
//     storeList.innerHTML = '';

//     if (!stores.length) {
//       storeList.innerHTML =
//         '<p style="width:100%;text-align:left;" class="no__store-text">No stores found</p>';
//       return;
//     }

//     stores.forEach(store => {
//       storeList.insertAdjacentHTML('beforeend', `
//         <div class="store-card">
//           ${store.image ? `<img src="${store.image}" alt="${store.name}">` : ''}
//           <div class="store-card__content">
//             <h3>${store.name}</h3>
//             <a href="${store.url}">Find Out More</a>
//           </div>
//         </div>
//       `);
//     });
//   }

//   function getDistance(lat1, lon1, lat2, lon2) {
//     const R = 6371;
//     const dLat = (lat2 - lat1) * Math.PI / 180;
//     const dLon = (lon2 - lon1) * Math.PI / 180;

//     const a =
//       Math.sin(dLat / 2) ** 2 +
//       Math.cos(lat1 * Math.PI / 180) *
//       Math.cos(lat2 * Math.PI / 180) *
//       Math.sin(dLon / 2) ** 2;

//     return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
//   }

//   /* =====================
//      🔥 INITIAL LOAD (FIXED)
//   ===================== */
//   populateCities();
//   renderAllStores();
// });


document.addEventListener('DOMContentLoaded', () => {

  const storeList = document.getElementById('store-list');
  const statusText = document.getElementById('search-status');
  const findNearestBtn = document.getElementById('find-nearest-btn');
  const radiusContainer = document.getElementById('radius-filter-container');

  const countryDropdown = document.getElementById('country-dropdown');
  const cityDropdown = document.getElementById('city-dropdown');

  if (!countryDropdown || !cityDropdown || !window.storeData) return;

  const countrySelected = countryDropdown.querySelector('.dropdown-selected');
  const citySelected = cityDropdown.querySelector('.dropdown-selected');

  const countryList = countryDropdown.querySelector('.dropdown-list');
  const cityList = cityDropdown.querySelector('.dropdown-list');

  const radiusButtons = document.querySelectorAll('.radius-option');
  const AVAILABLE_RADII = [10, 20, 30, 40, 50];

  let userLocation = null;

  /* =====================
     NORMALIZE STORE DATA
  ===================== */

//   window.storeData.forEach((store, i) => {
//   if (store.country == null || store.city == null) {
//     console.log('Bad store at index', i, store);
//   }
// });
  const stores = window.storeData.map(store => ({
    ...store,
    country: store.country.trim().toUpperCase(),
    city: store.city.trim()
  }));

  

  /* =====================
     DEFAULT STATE
  ===================== */
  let selectedCountry = 'UK';
  let selectedCity = 'All';

  /* =====================
     INIT COUNTRIES
  ===================== */
  const countries = [...new Set(stores.map(s => s.country))];

  countryList.innerHTML = '';
  countries.forEach(c => {
    countryList.insertAdjacentHTML(
      'beforeend',
      `<li data-value="${c}" class="${c === selectedCountry ? 'active' : ''}">${c}</li>`
    );
  });

  countrySelected.dataset.value = selectedCountry;
  countrySelected.querySelector('.selected-text').textContent = selectedCountry;

  citySelected.dataset.value = 'All';
  citySelected.querySelector('.selected-text').textContent = 'All';

  /* =====================
     COUNTRY CHANGE
  ===================== */
  countryList.addEventListener('click', e => {
    if (e.target.tagName !== 'LI') return;

    selectedCountry = e.target.dataset.value;
    selectedCity = 'All';

    countrySelected.dataset.value = selectedCountry;
    countrySelected.querySelector('.selected-text').textContent = selectedCountry;

    countryList.querySelectorAll('li').forEach(li => li.classList.remove('active'));
    e.target.classList.add('active');

    citySelected.dataset.value = 'All';
    citySelected.querySelector('.selected-text').textContent = 'All';

    populateCities();
    renderAllStores();
  });

  /* =====================
     CITY CHANGE
  ===================== */
  cityList.addEventListener('click', e => {
    if (e.target.tagName !== 'LI') return;

    selectedCity = e.target.dataset.value;

    citySelected.dataset.value = selectedCity;
    citySelected.querySelector('.selected-text').textContent = selectedCity;

    cityList.querySelectorAll('li').forEach(li => li.classList.remove('active'));
    e.target.classList.add('active');

    renderAllStores();
  });

  /* =====================
     POPULATE CITIES
  ===================== */
  function populateCities() {
    cityList.innerHTML = `<li data-value="All" class="active">All</li>`;
    cityDropdown.classList.remove('disabled');

    const cities = [...new Set(
      stores
        .filter(s => s.country === selectedCountry)
        .map(s => s.city)
    )];

    cities.forEach(city => {
      cityList.insertAdjacentHTML(
        'beforeend',
        `<li data-value="${city}">${city}</li>`
      );
    });
  }

  /* =====================
     FIND NEAREST
  ===================== */
  if (findNearestBtn) {
    findNearestBtn.addEventListener('click', () => {
      if (!navigator.geolocation) return;

      navigator.geolocation.getCurrentPosition(pos => {
        userLocation = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude
        };

        radiusContainer.classList.remove('hidden');
        autoSelectRadius();
      });
    });
  }

  function autoSelectRadius() {
    for (let radius of AVAILABLE_RADII) {
      const storesInRange = getStoresInRadius(radius);
      if (storesInRange.length) {
        setActiveRadius(radius);
        renderStores(storesInRange);
        updateStatus(storesInRange.length, radius);
        return;
      }
    }

    renderStores([]);
    updateStatus(0, AVAILABLE_RADII.at(-1));
  }

  radiusButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      if (!userLocation) return;

      const radius = parseInt(btn.dataset.radius, 10);
      setActiveRadius(radius);

      const storesInRange = getStoresInRadius(radius);
      renderStores(storesInRange);
      updateStatus(storesInRange.length, radius);
    });
  });

  function setActiveRadius(radius) {
    radiusButtons.forEach(btn =>
      btn.classList.toggle('active', parseInt(btn.dataset.radius, 10) === radius)
    );
  }

  function updateStatus(count, radius) {
    statusText.textContent = count
      ? `${count} store${count > 1 ? 's' : ''} found within ${radius} km`
      : `No stores found within ${radius} km`;
  }

  function getStoresInRadius(radius) {
    return stores.filter(store => {
      if (store.country !== selectedCountry) return false;
      if (selectedCity !== 'All' && store.city !== selectedCity) return false;

      const d = getDistance(
        userLocation.lat,
        userLocation.lng,
        store.lat,
        store.lng
      );
      return d <= radius;
    });
  }

  /* =====================
     RENDER STORES
  ===================== */
  function renderAllStores() {
    let filtered = stores.filter(s => s.country === selectedCountry);

    if (selectedCity !== 'All') {
      filtered = filtered.filter(s => s.city === selectedCity);
    }

    renderStores(filtered);
    statusText.textContent = '';
  }

  function renderStores(stores) {
    storeList.innerHTML = '';

    if (!stores.length) {
      storeList.innerHTML =
        '<p style="width:100%;text-align:left;" class="no__store-text">No stores found</p>';
      return;
    }

    

    stores.forEach(store => {
      storeList.insertAdjacentHTML('beforeend', `
        <div class="store-card">
          ${store.image ? `<img src="${store.image}" alt="${store.name}">` : ''}
          <div class="store-card__content">
            <div class="store-card__overlay"></div>
            <h3>${store.name}</h3>
            <a href="${store.url}">Find Out More</a>
          </div>
        </div>
      `);
    });
  }

  function getDistance(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1 * Math.PI / 180) *
      Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) ** 2;

    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  }

  /* =====================
     INITIAL LOAD
  ===================== */
  populateCities();
  renderAllStores();

});
